'use strict';

export const NOTIFICATIONS_LIST_NAME = 'notifications';

const SHOW_PANEL = '@@notifications/SHOW_PANEL';
const HIDE_PANEL = '@@notifications/HIDE_PANEL';
const SHOW_BUTTON = '@@notifications/SHOW_BUTTON';
const HIDE_BUTTON = '@@notifications/HIDE_BUTTON';
const UPDATE_SIZE = '@@notifications/UPDATE_SIZE';
const UPDATE_STATE = '@@notifications/UPDATE_STATE';


/**
 * @return {ReduxAction<Void>}
 */
export function showPanel() {
  return {
    type: SHOW_PANEL,
    payload: {},
  };
}
showPanel.TYPE = SHOW_PANEL;

/**
 * @return {ReduxAction<Void>}
 */
export function hidePanel() {
  return {
    type: HIDE_PANEL,
    payload: {},
  };
}
hidePanel.TYPE = HIDE_PANEL;

/**
 * @return {ReduxAction<Void>}
 */
export function showButton() {
  return {
    type: SHOW_BUTTON,
    payload: {},
  };
}
showButton.TYPE = SHOW_BUTTON;

/**
 * @return {ReduxAction<Void>}
 */
export function hideButton() {
  return {
    type: HIDE_BUTTON,
    payload: {},
  };
}
hideButton.TYPE = HIDE_BUTTON;

/**
 * @typedef {Object} NotificationsActions~UpdateSizePayload
 * @property {Number} size
 */

/**
 * This action is a stop-gap until the whole service is converted to redux.
 * @param {NotificationsActions~UpdateSizePayload} payload
 * @return {ReduxAction<NotificationsActions~UpdateSizePayload>}
 */
export function updateSize(payload) {
  return {
    type: UPDATE_SIZE,
    payload: payload,
  };
}
updateSize.TYPE = UPDATE_SIZE;

/**
 * @typedef {Object} NotificationsActions~UpdateStatePayload
 * @property {NoteState} state
 */

/**
 *
 * @param {NotificationsActions~UpdateStatePayload} payload
 * @return {ReduxAction<NotificationsActions~UpdateStatePayload>}
 */
export function updateState(payload) {
  return {
    type: UPDATE_STATE,
    payload: payload,
  };
}
updateState.TYPE = UPDATE_STATE;


/**
 * @typedef {Object} NotificationsActions
 * @property {Function|ReduxActionCreator<Void>} showPanel
 * @property {Function|ReduxActionCreator<Void>} hidePanel
 * @property {Function|ReduxActionCreator<Void>} showButton
 * @property {Function|ReduxActionCreator<Void>} hideButton
 * @property {Function|ReduxActionCreator<NotificationsActions~UpdateSizePayload>} updateSize
 * @property {Function|ReduxActionCreator<NotificationsActions~UpdateStatePayload>} updateState
 */



// WEBPACK FOOTER //
// ./src/js/system/actions/notificationsActions.js